import { render, staticRenderFns } from "./slideShow.vue?vue&type=template&id=bf708f24&scoped=true"
import script from "./slideShow.vue?vue&type=script&lang=js"
export * from "./slideShow.vue?vue&type=script&lang=js"
import style0 from "./slideShow.vue?vue&type=style&index=0&id=bf708f24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf708f24",
  null
  
)

export default component.exports